// extracted by mini-css-extract-plugin
module.exports = {"PlainFeature":"os_a"};